import { initializeApp, type FirebaseApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, type Auth } from 'firebase/auth';
import { env } from '@/lib/env';

/**
 * Lazy singleton, on purpose: authContext.tsx imports both providers so it can
 * choose between them, so importing this module must not construct anything.
 * A missing env var then surfaces at the sign-in screen rather than crashing
 * the whole SPA at module-import time — including the VITE_AUTH_MODE=fake
 * path, which has no Firebase config at all.
 */
let app: FirebaseApp | null = null;
let auth: Auth | null = null;

function firebaseApp(): FirebaseApp {
  app ??= initializeApp({
    apiKey: env.VITE_FIREBASE_API_KEY,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: env.VITE_FIREBASE_PROJECT_ID,
  });
  return app;
}

export function firebaseAuth(): Auth {
  if (!auth) {
    auth = getAuth(firebaseApp());

    // Dev/CI only; env.ts refuses this variable in a production build the same
    // way it refuses VITE_AUTH_MODE=fake. Must run before anything else touches
    // the instance, which is why it happens here rather than in initialize().
    if (env.VITE_FIREBASE_AUTH_EMULATOR_URL) {
      connectAuthEmulator(auth, env.VITE_FIREBASE_AUTH_EMULATOR_URL, { disableWarnings: false });
    }
  }
  return auth;
}
